export default __webpack_public_path__ + "img/b23ef7b19ec4452e4e8d7e95c3d17a13.mp4";